import ContentBox from "../../components/UI/ContentBox";
import Footer from "../../components/UI/Footer";
import Menu from "../../components/UI/Menu";
import {
  Container,
  Description,
  DivDocs,
  DivViewDocs,
  Icon,
  LinkDoc,
  Text,
  Title,
} from "./styles";
import BookItem from "../../components/UI/BookItem";
import InputSearch from "../../components/UI/Inputs/InputSearch";
import { images, icons } from "../../constants";
import Banner from "../../components/UI/Banner";
import useApi from "../../hooks/useApi";
import { useEffect } from "react";
import { useState } from "react";
import InView from "react-intersection-observer";
import FullScreenLoading from "../../components/UI/FullScreenLoading";
import { useTheme } from "../../hooks/useTheme";

import formacao_educacaoinclusiva from "../../assets/docs/formacao_educacaoinclusiva.pdf";
import tecnologia_assistiva_inclusiva from "../../assets/docs/tecnologia_assistiva_inclusiva.pdf";
import guiatranstornos from "../../assets/docs/guiatranstornos.pdf";
import ebookNau from "../../assets/docs/ebookNau.pdf";
import cartilha_dificuldadestranstornos from "../../assets/docs/cartilha_dificuldadestranstornos.pdf";
import orientacoesfamilia_edespecial from "../../assets/docs/orientacoesfamilia_edespecial.pdf";
import CDM_Volume1 from "../../assets/docs/CadernosdoMEC/Volume1.pdf";
import CDM_Volume2 from "../../assets/docs/CadernosdoMEC/Volume2.pdf";
import CDM_Volume3 from "../../assets/docs/CadernosdoMEC/Volume3.pdf";
import CDM_Volume4 from "../../assets/docs/CadernosdoMEC/Volume4.pdf";
import CDM_Volume5 from "../../assets/docs/CadernosdoMEC/Volume5.pdf";
import CDM_Volume6 from "../../assets/docs/CadernosdoMEC/Volume6.pdf";
import CDM_Volume7 from "../../assets/docs/CadernosdoMEC/Volume7.pdf";
import CDM_Volume8 from "../../assets/docs/CadernosdoMEC/Volume8.pdf";
import CDM_Volume9 from "../../assets/docs/CadernosdoMEC/Volume9.pdf";
import CDM_Volume10 from "../../assets/docs/CadernosdoMEC/Volume10.pdf";
import CDM_Volume11 from "../../assets/docs/CadernosdoMEC/Volume11.pdf";
import CDM_Volume12 from "../../assets/docs/CadernosdoMEC/Volume12.pdf";
import CDM_Volume13 from "../../assets/docs/CadernosdoMEC/Volume13.pdf";
import CDM_Volume14 from "../../assets/docs/CadernosdoMEC/Volume14.pdf";

const openForm = () => {
  window.open("https://iparadigma.org.br/tag-biblioteca/educacao-inclusiva/");
};

const openMatPed = () => {
  window.open("https://diversa.org.br/materiais-pedagogicos/");
};


const SchoolSpecialDocs = () => {
  const [search, setSearch] = useState("");
  const [newsLibrary, setNewsLibrary] = useState([]);
  const { themeFile } = useTheme();
  const [initialLoading, setInitialLoading] = useState(true);

  const [loadLibrary, loadLibraryInfo] = useApi({
    debounceDelay: 0,
    url: "canalPedagogico/library/publicNews/",
    method: "get",
    onCompleted: (response) => {
      if (!response.error) {
        console.log("Library", response.data);
        if (response.data.length > 0) {
          let result = [];
          response.data.forEach((item) => {
            const found = newsLibrary.findIndex((news) => news.id === item.id);
            if (found === -1) {
              return result.push(item);
            }
          });
          setNewsLibrary([...newsLibrary, ...result]);
        }
        setInitialLoading(false);
      }
    },
  });

  const [searchLibrary, searchLibraryInfo] = useApi({
    debounceDelay: 1000,
    url: "canalPedagogico/library/publicNews/",
    method: "get",
    onCompleted: (response) => {
      if (!response.error) {
        console.log("Library", response.data);
        if (response.data.length > 0) {
          let result = [];
          response.data.forEach((item) => {
            const found = newsLibrary.findIndex((news) => news.id === item.id);
            if (found === -1) {
              return result.push(item);
            }
          });
          setNewsLibrary([...newsLibrary, ...result]);
        }
      }
    },
  });

  const handleSearch = (event) => {
    setSearch(event.target.value);
    if (event.target.value.length > 2) {
      setNewsLibrary([]);
      console.log("pode fazer a busca");
      searchLibrary({
        params: {
          term: event.target.value.trim(),
          initial: 0,
          limit: 10,
        },
        debounced: true,
      });
    }

    if (event.target.value.length === 0) {
      setNewsLibrary([]);
      searchLibrary({
        params: {
          term: event.target.value,
          initial: 0,
          limit: 10,
        },
        debounced: true,
      });
    }
  };

  useEffect(() => {
    loadLibrary({
      params: {
        term: search,
        initial: 0,
        limit: 10,
      },
    });
    // eslint-disable-next-line
  }, []);

  const loadMore = (InviewObj, entry) => {
    if (InviewObj) {
      console.log("carregar mais");
      loadLibrary({
        params: {
          term: search,
          initial: newsLibrary.length + 1,
          limit: 10,
        },
      });
    }
  };

  return (
    <Container>
      {(initialLoading || loadLibraryInfo.loading) && <FullScreenLoading />}
      <Menu />
      <Banner
        icon={images.icon_autismo}
        // url="/biblioteca/admin"
        // editorId="f0d87522-fcc7-4f8b-aec3-3e64fce9915a"
      >
        DOCUMENTOS - EDUCAÇÃO ESPECIAL
      </Banner>
      {/* <Search>
        <InputSearch
          placeholder="Qual documento você procura?"
          value={search}
          onChange={handleSearch}
          onClick={handleSearch}
          loading={searchLibraryInfo.loading}
        />
      </Search> */}
      <ContentBox>
          <Description>
            Neste espaço você vai encontrar documentos de apoio aos profissionais da educação e pais sobre a educação especial.
          </Description>

      <Title>Apoio para o profissional da educação:</Title>
      <DivDocs>
        <Icon src={icons.documentos_black} />
        <DivViewDocs>
            <Text>Cartilha sobre Dificuldades e Transtornos de Aprendizagem</Text>
            <LinkDoc href={cartilha_dificuldadestranstornos} target="_blank">* Clique aqui para baixar o documento completo</LinkDoc>
        </DivViewDocs>
      </DivDocs>

      <DivDocs>
        <Icon src={icons.documentos_black} />
        <DivViewDocs>
            <Text>E-book Fazemos parte deste mundo e somos autistas</Text>
            <LinkDoc href={ebookNau} target="_blank">* Clique aqui para baixar o documento completo</LinkDoc>
        </DivViewDocs>
      </DivDocs>

      <DivDocs>
        <Icon src={icons.documentos_black} />
        <DivViewDocs>
            <Text>Guia dos principais transtornos do neurodesenvolvimento</Text>
            <LinkDoc href={guiatranstornos} target="_blank">* Clique aqui para baixar o documento completo</LinkDoc>
        </DivViewDocs>
      </DivDocs>

      <DivDocs>
        <Icon src={icons.documentos_black} />
        <DivViewDocs>
            <Text>Tecnologia assistiva para uma educação inclusiva</Text>
            <LinkDoc href={tecnologia_assistiva_inclusiva} target="_blank">* Clique aqui para baixar o documento completo</LinkDoc>
        </DivViewDocs>
      </DivDocs>

      <DivDocs>
        <Icon src={icons.documentos_black} />
        <DivViewDocs>
            <Text>Materiais Pedagógicos: referências sobre como produzir materiais pedagógicos acessíveis - 
              DIVERSA, uma iniciativa Instituto Rodrigo Mendes.</Text>
            <LinkDoc onClick={openMatPed} target="_blank">* Clique aqui para acessar o material completo</LinkDoc>
        </DivViewDocs>
      </DivDocs>

      <DivDocs>
        <Icon src={icons.documentos_black} />
        <DivViewDocs>
            <Text>Formações em Educação Especial, Inclusiva e Acessibilidade para
            Profissionais da Educação</Text>
            <LinkDoc href={formacao_educacaoinclusiva} target="_blank">* Clique aqui para baixar o documento completo</LinkDoc>
        </DivViewDocs>
      </DivDocs>

    <DivDocs>
        <Icon src={icons.documentos_black} />
        <DivViewDocs>
            <Text>Biblioteca Virtual: Educação Inclusiva - Instituto Paradigma, pessoas incluindo pessoas</Text>
            <LinkDoc onClick={openForm} target="_blank">* Clique aqui para acessar</LinkDoc>
        </DivViewDocs>
      </DivDocs>

      <Title>Cadernos Pedagógicos Política Nacional de Educação Especial Inclusiva</Title>
      <DivDocs>
        <Icon src={icons.documentos_black} />
        <DivViewDocs>
            <Text>Volume 1 – Política de Educação Especial Inclusiva concepções, fundamentos e princípios</Text>
            <LinkDoc href={CDM_Volume1} target="_blank">* Clique aqui para baixar o documento completo</LinkDoc>
        </DivViewDocs>
      </DivDocs>

      <DivDocs>
        <Icon src={icons.documentos_black} />
        <DivViewDocs>
            <Text>Volume 2 – Atendimento Educacional Especializado (AEE) Concepções e Metodologias</Text>
            <LinkDoc href={CDM_Volume2} target="_blank">* Clique aqui para baixar o documento completo</LinkDoc>
        </DivViewDocs>
      </DivDocs>

      <DivDocs>
        <Icon src={icons.documentos_black} />
        <DivViewDocs>
            <Text>Volume 3 – Documentação do AEE na Escola Inclusiva Estudo de Caso, PAEE e PEI</Text>
            <LinkDoc href={CDM_Volume3} target="_blank">* Clique aqui para baixar o documento completo</LinkDoc>
        </DivViewDocs>
      </DivDocs>

      <DivDocs>
        <Icon src={icons.documentos_black} />
        <DivViewDocs>
            <Text>Volume 4 – Práticas pedagógicas inclusivas em salas de aula</Text>
            <LinkDoc href={CDM_Volume4} target="_blank">* Clique aqui para baixar o documento completo</LinkDoc>
        </DivViewDocs>
      </DivDocs>

      <DivDocs>
        <Icon src={icons.documentos_black} />
        <DivViewDocs>
            <Text>Volume 5 – Educação Inclusiva e Tecnologia Assistiva</Text>
            <LinkDoc href={CDM_Volume5} target="_blank">* Clique aqui para baixar o documento completo</LinkDoc>
        </DivViewDocs>
      </DivDocs>

      <DivDocs>
        <Icon src={icons.documentos_black} />
        <DivViewDocs>
            <Text>Volume 6 – Práticas Inclusivas e Estudantes Autistas</Text>
            <LinkDoc href={CDM_Volume6} target="_blank">* Clique aqui para baixar o documento completo</LinkDoc>
        </DivViewDocs>
      </DivDocs>

      <DivDocs>
        <Icon src={icons.documentos_black} />
        <DivViewDocs>
            <Text>Volume 7 – Práticas Inclusivas e Estudantes com Altas Habilidades ou Superdotação</Text>
            <LinkDoc href={CDM_Volume7} target="_blank">* Clique aqui para baixar o documento completo</LinkDoc>
        </DivViewDocs>
      </DivDocs>

      <DivDocs>
        <Icon src={icons.documentos_black} />
        <DivViewDocs>
            <Text>Volume 8 – Práticas Inclusivas e Estudantes com Deficiências Sensoriais</Text>
            <LinkDoc href={CDM_Volume8} target="_blank">* Clique aqui para baixar o documento completo</LinkDoc>
        </DivViewDocs>
      </DivDocs>

      <DivDocs>
        <Icon src={icons.documentos_black} />
        <DivViewDocs>
            <Text>Volume 9 – Infâncias e Educação Especial Inclusiva</Text>
            <LinkDoc href={CDM_Volume9} target="_blank">* Clique aqui para baixar o documento completo</LinkDoc>
        </DivViewDocs>
      </DivDocs>

      <DivDocs>
        <Icon src={icons.documentos_black} />
        <DivViewDocs>
            <Text>Volume 10 – Práticas Inclusivas em Alfabetização e Letramento</Text>
            <LinkDoc href={CDM_Volume10} target="_blank">* Clique aqui para baixar o documento completo</LinkDoc>
        </DivViewDocs>
      </DivDocs>

      <DivDocs>
        <Icon src={icons.documentos_black} />
        <DivViewDocs>
            <Text>Volume 11 – Atendimento Educacional Especializado em Ambiente Hospitalar ou Domiciliar</Text>
            <LinkDoc href={CDM_Volume11} target="_blank">* Clique aqui para baixar o documento completo</LinkDoc>
        </DivViewDocs>
      </DivDocs>

      <DivDocs>
        <Icon src={icons.documentos_black} />
        <DivViewDocs>
            <Text>Volume 12 – Educação Inclusiva e Intersetorialidade</Text>
            <LinkDoc href={CDM_Volume12} target="_blank">* Clique aqui para baixar o documento completo</LinkDoc>
        </DivViewDocs>
      </DivDocs>

      <DivDocs>
        <Icon src={icons.documentos_black} />
        <DivViewDocs>
            <Text>Volume 13 – Educação Inclusiva e Profissional de Apoio Escolar</Text>
            <LinkDoc href={CDM_Volume13} target="_blank">* Clique aqui para baixar o documento completo</LinkDoc>
        </DivViewDocs>
      </DivDocs>

      <DivDocs>
        <Icon src={icons.documentos_black} />
        <DivViewDocs>
            <Text>Volume 14 – Gestão Escolar Inclusiva</Text>
            <LinkDoc href={CDM_Volume14} target="_blank">* Clique aqui para baixar o documento completo</LinkDoc>
        </DivViewDocs>
      </DivDocs>

      <Title>Orientações para a família:</Title>
      <DivDocs>
        <Icon src={icons.documentos_black} />
        <DivViewDocs>
            <Text>Material de apoio para os pais da educação especial e inclusiva, com orientações como
            emitir cartão de identificação, credenciamento de estacionamento entre outros.</Text>
            <LinkDoc href={orientacoesfamilia_edespecial} target="_blank">* Clique aqui para baixar o documento completo</LinkDoc>
        </DivViewDocs>
      </DivDocs>

      

        {/* <Feed>
          {newsLibrary?.length > 0 &&
            newsLibrary?.map((item) => (
              <BookItem
                key={item.id}
                id={item.id}
                image={
                  process.env.REACT_APP_CDN_URL +
                  "canalPedagogico/libraryNews/" +
                  item.image
                }
                title={item.title}
                description={item.description}
                url={`/biblioteca/news/editar/${item.id}`}
                editorId="f0d87522-fcc7-4f8b-aec3-3e64fce9915a"
                mainCategory="Biblioteca"
              />
            ))}
          {newsLibrary?.length > 0 && (
            <InView
              as="div"
              onChange={(inView, entry) => loadMore(inView, entry)}
            ></InView>
          )}
        </Feed> */}

        {/* {!searchMain ? (
          <Main>
            {docType.map((tipo, index) => (
              <List key={`list${index}`}>
                <Title
                  onClick={() => {
                    setDropFlag(dropFlag === tipo.id ? "" : tipo.id);
                  }}
                >
                  <Icon src={icons.documentos_black} />
                  {tipo.category}
                  <span>
                    {dropFlag === tipo.id ? (
                      <MdArrowDropUp />
                    ) : (
                      <MdArrowDropDown />
                    )}
                  </span>
                  {(loadDocumentsInfo.loading ||
                    loadDocumentsPublicInfo.loading) &&
                    documentos.length === 0 &&
                    dropFlag === tipo.id && (
                      <Loading>
                        <LoadingItem />
                      </Loading>
                    )}
                </Title>
                {documentos.map((documentoTemp, indexdocumento) => (
                  <Document 
                    doc={documentoTemp}
                    isEditor={isEditor(documentoTemp.type)}
                    search={searchMain}
                    visible={dropFlag === tipo.id}
                    key={documentoTemp.id}
                  />
                ))}
                {(loadDocumentsInfo.loading ||
                  loadDocumentsPublicInfo.loading) &&
                  dropFlag === tipo.id && (
                    <LoadingMore>
                      <span>
                        <LoadingItem />
                      </span>
                    </LoadingMore>
                  )}
                {documentos.length > 0 && dropFlag === tipo.id && (
                  <InView
                    as="div"
                    onChange={(inView, entry) =>
                      loadMoreDocument(inView, entry)
                    }
                  ></InView>
                )}
              </List>
            ))}
          </Main>
        ) : (
          <Main>
            {searchDocument.length > 0 && (
              <SearchMessage total={searchDocument.length} time={time} />
            )}
            {searchDocument.length > 0
              ? searchDocument.map((documentoTemp, index) => (
                  <Document 
                    doc={documentoTemp}
                    isEditor={isEditor(documentoTemp.type)}
                    search={searchMain}
                    visible={true}
                    key={index}
                  />
                ))
              : !(
                  loadSearchDocumentsInfo.loading ||
                  loadSearchDocumentsPublicInfo.loading
                ) && (
                  <SearchMessage
                    message={`Sua busca por "${textSearch}" não encontrou resultados.`}
                  />
                )}
            {searchDocument.length > 0 && (
              <InView
                as="div"
                onChange={(inView, entry) => loadMore(inView, entry)}
              ></InView>
            )}
          </Main>
        )} */}

      </ContentBox>
      <Footer />
    </Container>
  );
};

export default SchoolSpecialDocs;
